import { createAsyncThunk } from "@reduxjs/toolkit";
import { AppThunkAPIType } from "../../../app/appTypes";
import { deleteWithAuth, getWithAuth, postWithAuth, putWithAuth } from "../../../http";
import { DocumentTeamMemberRole } from "../../documents/components/teamMemberApi";

export interface SystemRoleResponsibility {
    id: string;
    roleCode: DocumentTeamMemberRole;
    responsibilityPl: string;
    responsibilityEn: string;
}

export type DraftSystemRoleResponsibility = Omit<SystemRoleResponsibility, "id">

export interface CreateSystemRoleResponsibility{
    roleCode: DocumentTeamMemberRole;
    responsibilityPl: string;
    responsibilityEn: string;
}

export const loadSystemRoleResponsibilities = createAsyncThunk<SystemRoleResponsibility[], void, AppThunkAPIType>("system-role-responsibilities/load", async (_, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(getWithAuth({ url: `api/sys/role-responsibilities` }))
    const { payload } = result
    if (getWithAuth.fulfilled.match(result)) {
        return payload as SystemRoleResponsibility[]
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const createSystemRoleResponsibility = createAsyncThunk<SystemRoleResponsibility, CreateSystemRoleResponsibility, AppThunkAPIType>("system-role-responsibilities/create", async (roleResponsibility, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(postWithAuth({ url: `api/sys/role-responsibilities`, payload: roleResponsibility }))
    const { payload } = result
    if (postWithAuth.fulfilled.match(result)) {
        return payload as SystemRoleResponsibility
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const updateSystemRoleResponsibility = createAsyncThunk<SystemRoleResponsibility, SystemRoleResponsibility, AppThunkAPIType>("system-role-responsibilities/update", async (roleResponsibility, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(putWithAuth({ url: `api/sys/role-responsibilities`, payload: roleResponsibility }))
    const { payload } = result
    if (putWithAuth.fulfilled.match(result)) {
        return payload as SystemRoleResponsibility
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const deleteSystemRoleResponsibility = createAsyncThunk<string, string, AppThunkAPIType>("system-role-responsibilities/delete", async (id, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(deleteWithAuth({ url: `api/sys/role-responsibilities/${id}` }))
    const { payload } = result
    if (deleteWithAuth.fulfilled.match(result)) {
        return payload as string
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})